import store from '@/store'
import { computed, onMounted, onUnmounted, watch } from '@vue/composition-api'

const useOwnStream = () => {
  const streamDocId = computed(() => store.state.usermedia.streamDocId)
  const streamDoc = computed(() => {
    if (streamDocId.value === null) return null
    return store.state.streams.subscribedStreams[streamDocId.value] ?? null
  })

  const wrtcServer = computed(() => store.state.usermedia.wrtcServer)

  watch(streamDocId, async (newVal, oldVal) => {
    if (oldVal !== null) await store.dispatch.streams.unsubscribeStream(oldVal)
    if (newVal !== null) await store.dispatch.streams.subscribeStream(newVal)
  })

  onMounted (async () => {
    if (streamDocId.value) await store.dispatch.streams.subscribeStream(streamDocId.value)
  })

  onUnmounted (async () => {
    if (streamDocId.value) await store.dispatch.streams.unsubscribeStream(streamDocId.value)
  })

  return {
    streamDocId,
    wrtcServer,
    streamDoc
  }
}

export default useOwnStream
